<template>
	<nav
		id="header"
		class="navbar navbar-light text-center justify-content-center"
	>
		<img src="/img/logo.png" alt="" />
	</nav>
</template>

<script>
export default {};
</script>